import { OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
var ProgressComponent = /** @class */ (function () {
    function ProgressComponent(router, changeDetector) {
        this.router = router;
        this.changeDetector = changeDetector;
        this.total = 100;
        this._value = 0;
        this.percentWidth = 0;
        this.ngUnsubscribe = new Subject();
    }
    Object.defineProperty(ProgressComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            this._value = value;
            this.percentWidth = this.value / this.total * 100;
            this.changeDetector.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    ProgressComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.router.events
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (event) {
            if (event instanceof NavigationStart) {
                _this.value = 0;
            }
        });
    };
    ProgressComponent.prototype.ngOnDestroy = function () {
        this.changeDetector.detach();
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return ProgressComponent;
}());
export { ProgressComponent };
